import { defineStore } from "pinia";

const urls = {
  chat: `/api/chat`,
  userInputChat: `/api/user-input-chat`,
  generalChatOptions: `/api/general-chat-options`,
  userFeedback: `/api/user-feedback`,
  fetchConfig: (financier) => `/api/is-chat-enabled/${financier}`,
};

export const useChatStore = defineStore("chat", {
  state: () => ({
    history: [],
    responseOptions: [],
    generalChatOptions: [],
    isGeneralChat: null,
    terminal: null,
    flowPosition: null,
    specialFieldFlowPosition: null,
    config: {},
  }),
  actions: {
    chat: async function (request) {
      try {
        if (process.client) {
          const {history, responseOptions, isGeneralChat, terminal} = await (await fetch(useRuntimeConfig().public.chatBaseUrl + urls.chat, {method: "POST", body: JSON.stringify(request)})).json();
          this.history = history;
          this.responseOptions = responseOptions;
          this.isGeneralChat = isGeneralChat;
          this.terminal = terminal;
        }
      } catch (err) {
        console.log(err);
        await Promise.reject(err);
      }
    },
    getConfig: async function (financier) {
      try {
        if (process.client) {
          const config = await (await fetch(useRuntimeConfig().public.chatBaseUrl + urls.fetchConfig(financier), {method: "GET"})).json();
          this.config = config;
        }
      } catch (err) {
        console.log(err);
        await Promise.reject(err);
      }
    },
    userInputChat: async function (request) {
      try {
        if (process.client) {
          const {history, responseOptions, isGeneralChat, terminal} = await (await fetch(useRuntimeConfig().public.chatBaseUrl + urls.userInputChat, {method: "POST", body: JSON.stringify(request)})).json();
          this.history = history ?? [];
          this.responseOptions = responseOptions ?? [];
          this.isGeneralChat = isGeneralChat;
          this.terminal = terminal;
        }
      } catch (err) {
        console.log(err);
        await Promise.reject(err);
      }
    },
    fetchGeneralChatOptions: async function (request) {
      try {
        if (process.client) {
          const generalChatOptions = await (await fetch(useRuntimeConfig().public.chatBaseUrl + urls.generalChatOptions, {method: "POST", body: JSON.stringify(request)})).json();
          this.generalChatOptions = generalChatOptions;
        }
      } catch (err) {
        console.log(err);
        await Promise.reject(err);
      }
    },
    setFlowPosition: function (flowPosition) {
      this.flowPosition = flowPosition;
    },
    sendUserFeedback: async function (request) {
      try {
        if (process.client) {
          await fetch(useRuntimeConfig().public.chatBaseUrl + urls.userFeedback, {method: "POST", body: JSON.stringify(request)})
        }
      } catch (err) {
        console.log(err);
        await Promise.reject(err);
      }
    }
  },
  getters: {
    getResponseOptions: (state) => state.responseOptions,
    getMessageHistory: (state) => state.history,
    isChatEnabled: (state) => state.config.enabled,
  },
});
